import type { ComponentProps } from 'react';

type VoxUpLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string, string];
};

const VoxUpLogo = ({ colors, ...props }: VoxUpLogoProps) => {
  return (
    <svg viewBox="0 0 74 16" focusable="false" role="img" {...props}>
      <title>VOX Up</title>
      <path
        fill={colors?.[0] ?? '#cf0338'}
        d="M73.275 2.894A5.6 5.6 0 0 0 71.28.782 5.3 5.3 0 0 0 68.45 0c-.843 0-1.647.2-2.387.593-.696.37-1.256.841-1.665 1.404V.222h-1.631v15.776h1.63V9.62c.41.563.97 1.035 1.666 1.404.741.393 1.544.593 2.387.593a5.3 5.3 0 0 0 2.831-.782 5.57 5.57 0 0 0 1.995-2.112c.48-.882.724-1.863.724-2.915a6 6 0 0 0-.724-2.915m-.95 2.922c0 .788-.173 1.517-.515 2.167a4 4 0 0 1-1.435 1.548c-.61.378-1.31.57-2.08.57s-1.47-.192-2.08-.57c-.61-.38-1.093-.9-1.434-1.548a4.6 4.6 0 0 1-.516-2.167c0-.788.174-1.516.516-2.165a4 4 0 0 1 1.434-1.548c.61-.379 1.31-.57 2.08-.57s1.47.191 2.08.57 1.093.9 1.435 1.548c.342.65.515 1.378.515 2.165"
      />
      <path
        fill={colors?.[1] ?? '#000'}
        d="M11.263 6.9 7.742.224H0L8.666 16h5.059l3.153-5.669-.003-.006a9 9 0 0 1-.306-2.321c.006-3.327 1.787-6.195 4.557-7.779h-6.4zM48.829.225h-8.656L38.218 2.81c-.642-.822-1.229-1.674-1.923-2.585H29.68c2.746 1.503 4.577 4.43 4.577 7.79a8.83 8.83 0 0 1-5.017 7.983h-.013 5.737l3.236-3.632A991 991 0 0 1 41.134 16h8.55l-7.247-8.367z"
      />
      <path
        fill={colors?.[2] ?? '#cf0338'}
        d="M58.792 5.787c0 .862-.144 1.63-.428 2.279-.284.648-.68 1.153-1.18 1.503-.5.348-1.062.525-1.67.525-.78 0-1.425-.286-1.916-.852-.492-.566-.742-1.326-.742-2.258V.222h-1.631v6.985c0 .875.176 1.654.524 2.316a3.85 3.85 0 0 0 1.454 1.547c.615.364 1.326.549 2.112.549.727 0 1.414-.182 2.044-.538a3.86 3.86 0 0 0 1.432-1.432v1.748h1.632V.222H58.79zM25.363 3.932a3.933 3.933 0 0 0-3.928 3.939 3.933 3.933 0 0 0 3.928 3.938 3.933 3.933 0 0 0 3.928-3.938 3.933 3.933 0 0 0-3.928-3.939"
      />
    </svg>
  );
};

export default VoxUpLogo;
